export const HIREOS_TENANT_BASE_URL = "https://accent-productions.hireos.co.nz";
export const HIREOS_INQUIRY_URL = `${HIREOS_TENANT_BASE_URL}/inquiry`;

export function buildHireOSURL(path: string, search = "", hash = "") {
  const url = new URL(path, HIREOS_TENANT_BASE_URL);
  url.search = search;
  url.hash = hash;
  return url.toString();
}
